// @flow
import styled from 'styled-components';
import { media } from '~/core/utils/style';
import SVGIcon from '~/core/icons/svg-icons';

const height = 4;
const heightText = 3;
const padding = 1;
export const ActionContainer = styled.div`
    border: ${p => (p.active ? 'solid' : 'dashed')} 1px ${p => p.theme.secondaryMedium};
    border-radius: ${padding}em;
    cursor: ${p => (p.active ? 'pointer' : 'inherit')};
    display: flex;
    flex-wrap: wrap;
    height: ${height + heightText + padding}em;
    margin-top: ${padding}em;
    padding: ${padding}em 0 0 0;
    transition: 0.3s;

    &:hover {
        box-shadow: 0 0 0.5em 0 ${p => p.theme.secondaryMedium};
    }

    ${media.tablet`
		flex-wrap: nowrap;
        height: ${height + 2 * padding}em;
        padding: ${padding}em 0;
	`};
`;

export const ActionIcons = styled.div`
    align-items: center;
    display: flex;
    flex: 1 0 12em;
    height: ${height}em;
    order: 1;
    padding-left: ${padding}em;

    ${media.tablet`
		flex: 0 0 14em;
	`};
`;

export const RemoveActionContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 0 0 4em;
    height: ${height}em;
    justify-content: flex-end;
    order: 2;
    padding: 0 ${padding}em;

    ${media.tablet`
		order: 4;
	`};
`;

export const RemoveActionButton = styled(SVGIcon)`
    height: 1.5em;
    margin: 0;
    width: 2em;
`;

export const Name = styled.div`
    align-items: center;
    display: flex;
    flex: 1 1 100%;
    height: ${heightText}em;
    order: 3;
    overflow: hidden;
    padding: 0 ${padding}em;

    & > span {
        font-size: 1.2em;
    }

    ${media.tablet`
        flex: 1 1 auto;
        height: ${height}em;
		order: 2;
	`};
`;

export const Status = styled.div`
    display: none;

    ${media.tablet`
        align-items: center;
        color: ${p => (p.enabled ? p.theme.mainBrandColor : 'inherit')};
        display: flex;
        flex: 0 0 6em;
        padding: 0 ${padding}em;
        order: 3;
    `};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/action/styles.js